<template>
    <table class="table is-striped is-size-7 is-narrow is-fullwidth">
    <thead>
        <tr v-if="mode == 'summary'">
            <td>Вариант</td>
            <td>Другое</td>
            <td>Комментарий</td>
        </tr>
        <tr v-else>
            <td>Ответы</td>
            <td>{{ label }}</td>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(item,index) in value" :key="index">
          <template v-if="mode == 'summary'">
            <td>
                <span>{{ $_.get(item, 'option') }}</span>
            </td>
            <td>
                <span>{{ $_.get(item, 'other') }}</span>
            </td>
            <td class="ellipsis">
                <span>{{ $_.get(item, 'comment') }}</span>
            </td>
          </template>
          <template v-else>
            <td>
                <span>{{ item[1] }}</span>
            </td>
            <td class="ellipsis">
                <span>{{ item[0] }}</span>
            </td>
          </template>
        </tr>
    </tbody>
    </table>
</template>

<style scoped>
/* Based on https://stackoverflow.com/a/30362531 */

.ellipsis {
  position: relative;
}

.ellipsis span {
  float: left; /* float instead of absolute position */
  hyphens: auto;
}
</style>

<script>
export default Vue.extend({
  props: {
    value: {
      type: [Object, Array],
      required: true
    },
    mode: {
      type: String,
      default: "comment"
    },
    label: {
      type: String,
      default: "Cодержимое"
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/survey/summary/TextSummary.vue